import * as React from 'react';
import styled from 'styled-components';
import IconAdd from './IconAdd';
import IconRemove from './IconRemove';
class DraftColumnOptions extends React.Component {
    constructor() {
        super(...arguments);
        this.addPlayerHandler = () => {
            this.props.handlers.showPlayerModal(this.props.playerPosition);
        };
        this.removePlayerHandler = () => {
            this.props.handlers.toggleRemovePlayerMode();
        };
    }
    render() {
        return (React.createElement(Container, null,
            React.createElement(IconAdd, { className: "button addPlayer", width: "18px", height: "18px", clicked: this.addPlayerHandler }),
            React.createElement(IconRemove, { className: "button removePlayer", width: "18px", height: "18px", clicked: this.removePlayerHandler })));
    }
}
;
export default DraftColumnOptions;
const Container = styled.div `
  display: inline-block;
  margin-left: 5px;
  padding: 5px;
  text-align: right;

  svg {
    cursor: pointer;
    margin: 0 5px;
  }

  .button {
    display: inline-block;
  }

  .addPlayer svg {
    fill: #008619;
  }

  .removePlayer svg {
    fill: #a00;
  }
`;
//# sourceMappingURL=DraftColumnOptions.js.map


// WEBPACK FOOTER //
// ./src/components/DraftColumnOptions.js